import React from 'react';
import {
  chakraComponents,
  GroupBase,
  ValueContainerProps,
} from 'chakra-react-select';
import { Flex } from '@chakra-ui/react';
import { SelectOption } from '../types';
import { IconWrapper } from './IconWrapper';
import { DetailedHTMLPropsWithTestId } from '../../ChakraAutocomplete/types';

export const ValueContainer = ({
  children,
  ...props
}: ValueContainerProps<SelectOption, false, GroupBase<SelectOption>>) => {
  const value = props.getValue()[0];

  return (
    <chakraComponents.ValueContainer
      {...props}
      innerProps={
        {
          'data-testid': props.selectProps.dataTestId,
        } as DetailedHTMLPropsWithTestId
      }
    >
      {value?.icon ? (
        <Flex alignItems="center" overflow="hidden">
          <IconWrapper icon={value.icon} />
          {children}
        </Flex>
      ) : (
        children
      )}
    </chakraComponents.ValueContainer>
  );
};
